import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["input", "label"]
  static values = { default: String }

  connect() {
    // tom-select initializes async, so wait a tick for it to be ready
    requestAnimationFrame(() => this.applyFieldStyle())
  }

  reset(event) {
    event.preventDefault()
    const el = this.inputTarget
    if (el.tomselect) {
      el.tomselect.setValue(this.defaultValue)
    } else {
      el.value = this.defaultValue || ""
    }
    this.showInherited()
  }

  change() {
    if (this.inputTarget.value !== this.defaultValue) {
      this.showOverridden()
    } else {
      this.showInherited()
    }
  }

  showInherited() {
    this.labelTarget.innerHTML = '<span style="color: #aaa;">from series</span>'
    this.applyFieldStyle()
  }

  showOverridden() {
    this.labelTarget.innerHTML =
      '<span style="color: #3498db; font-weight: 600;">Overridden</span>' +
      ' <a href="#" data-action="click->field-override#reset" style="color: #e74c3c; text-decoration: underline; font-weight: 400; margin-left: 4px;">Reset</a>'
    this.applyFieldStyle()
  }

  applyFieldStyle() {
    const isOverridden = this.inputTarget.value !== this.defaultValue && this.inputTarget.value !== ""
    const el = this.inputTarget
    const ts = el.tomselect
    const control = ts ? ts.control : null

    if (isOverridden) {
      if (control) {
        control.style.borderColor = "#3498db"
        control.style.backgroundColor = "#dbedf9"
        control.style.color = "#000"
      } else {
        el.style.borderColor = "#3498db"
        el.style.backgroundColor = "#eaf4fd"
        el.style.color = "#000"
      }
    } else {
      if (control) {
        control.style.borderColor = ""
        control.style.backgroundColor = ""
        control.style.color = "#aaa"
      } else {
        el.style.borderColor = ""
        el.style.backgroundColor = ""
        el.style.color = "#aaa"
      }
    }
  }
}
